<form [formGroup]="FormGroup">
  <div class="row">
    <div class="input-group">
      <input
        id="location-search"
        type="text"
        [formControlName]="controlName"
        placeholder="Escribe para buscar..."
        class="form-control"
        [ngbTypeahead]="searchLocationFilter"
        [resultFormatter]="resultFormatLocationListValue"
        [inputFormatter]="resultFormatLocationListValue"
        [editable]="false" />
      <span class="input-group-text">
        <ng-container *ngIf="!isLoadingLocationSearch; else loadingContent">
          <fa-icon [icon]="faSearch"></fa-icon>
        </ng-container>
        <ng-template #loadingContent>
          <div
            class="spinner-border text-primary"
            role="status"
            style="height: 20px; width: 20px">
            <span class="visually-hidden">Loading...</span>
          </div>
        </ng-template>
      </span>
    </div>
  </div>
</form>
